export var AccountPanes;

(function (AccountPanes) {
  AccountPanes["LoginPane"] = "Login";
  AccountPanes["ForgotPassPane"] = "ForgotPassword";
  AccountPanes["NewPassPane"] = "NewPassword";
  AccountPanes["ConnectExternalAccount"] = "ConnectExternalAccount";
  AccountPanes["NewPassSuperUserPane"] = "NewPasswordSuperUser";
})(AccountPanes || (AccountPanes = {}));